import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  excluded: {
    display: 'flex',
    flexDirection: 'column'
  }
});

export default makeStyles(styles);
